<template>

  <div class="atividades-ponpontoeletronicovalidacoes ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
<!--
              <b-col cols="3">
                <label for="select-empresa">Empresa</label> 
                <multiselect  id="selecao-empresa-sol"  v-model="value_empresa" required                  
                  :options="empresas" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false" 
                  :preserve-search="true" placeholder="Selecione a empresa" label="empresa" track-by="empresa" name="empresa"
                  :preselect-first="true">                  
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>
-->
              <b-col cols="6">
                <label for="select-garagem_sol">Filial</label>
                <multiselect id="selecao-filial-sol"  v-model="value_filial" required 
                  
                  :options="filiais" 
                  :multiple="true" 
                   :taggable="true" 
                  @close="loadponpontoeletronicovalidacoes()"  
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a filial" label="filial" track-by="filial" name="filial"
                  :preselect-first="true">
                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Filial selecionada</span></template>
                </multiselect> 
              </b-col>

              <!--

              <b-col cols="3">
                   <label for="select-status">Competência</label>  

                <multiselect id="selecao-status-sol" v-model="value_status"  required  
                :options="statuss" 
                :multiple="true"         
                :taggable="true"  
                @close="loadponpontoeletronicovalidacoes()"  
                @tag="addTag"                           
                :close-on-select="false" 
                :clear-on-select="false" 
                :preserve-search="true" placeholder="Status" label="status" track-by="status" name="status"
                :preselect-first="true">                 
                <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} status selecionado</span></template>
                </multiselect>                
              </b-col> 
              -->

              <b-col cols="6"  class="mb-0">
                <label  for="input-busca">Pesquisa no grid por: </label> 
                <b-form-input id="buscamonitoramento" v-model="search"  required="required" placeholder="Registro ou Nome ou Função"></b-form-input>              
              </b-col>   

<!--
              <b-col cols="2">
                <br>                 
                <b-button variant="primary" class="mr-2 mt-2" :disabled="carregando" @click="carregando = true,loadponpontoeletronicovalidacoes()">
                  <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Atualizar grid
                </b-button>                      
              </b-col>
-->

          </b-row>
    </b-form>



    <b-col>
      <div >                     
       
       <b-progress class="mt-3 mp-3" :max="barra_limite">
        <b-progress-bar variant="success"  :value="barra_inicial" :label="`${((barra_inicial / barra_limite) * 100).toFixed(2)} %`"></b-progress-bar>
      </b-progress>

      </div>
    </b-col>


    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
    <!--tbl de dados -->
    <b-table id="pon_pontoeletronicovalidacao"  small hover striped sticky-header="756px"  :items="itemsFiltered" :fields="fields" >    
        <template slot="cell(actions)" slot-scope="data"  >
          <b-button  @click="loadCarregaSac(data.item)"    title="Acessar solicitação"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.modal-multi-1>                
            <i class="fa fa-exclamation-circle"></i>              
          </b-button> 
        </template>   
    </b-table>

      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <div>        
    <b-modal id="modal-multi-1"  ok-title="Fechar" ok-only size="sm" title="Foto validação"   no-close-on-esc no-close-on-backdrop>
          <!-- -->
          <div>

            <b-row>
              <input  id="id-sac" type="hidden" v-model="ponpontoeletronicovalidacao.id_pdf_confirmed" />

              <b-col cols="1" class="mt-2  pr-4" center >
                  <b-form-group label="" label-for="tabela-foto">
                    <b-img                       height="400" width="260"                          class="mb-5" 
                        v-model="ponpontoeletronicovalidacao.foto"                         
                        v-bind="mainProps" rounded alt="Foto"
                        
                        :src="ponpontoeletronicovalidacao.foto"
                    >
                    </b-img>
                  </b-form-group>                  
              </b-col>
            </b-row> 

            <b-row>
              <b-col sm="12">                
                <label for="textarea-small">Registro......:</label> - {{ponpontoeletronicovalidacao.registro}}
              </b-col>
            </b-row>                      
            <b-row>
              <b-col sm="12">                
                <label for="textarea-small">Função........:</label> - {{ponpontoeletronicovalidacao.funcao}}
              </b-col>
            </b-row>            

            <b-row>
              <b-col sm="12">                
                <label for="textarea-small">Data Validação:</label> - {{moment(ponpontoeletronicovalidacao.data_cadastro).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-')}}
              </b-col>
            </b-row>            
          </div>
          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->

  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import { mapState } from 'vuex' 


export default {    
    name: 'ponpontoeletronicovalidacao',    

    
    computed : { ... mapState (['user'],),
    
      itemsFiltered(){
        let valores = [];
       // const values = Object.values(obj);
        valores = this.ponpontoeletronicovalidacoes.filter((item) =>{
          return (
            item.registro.indexOf(this.search) >-1 || item.funcao.indexOf(this.search) >-1 || item.nome.indexOf(this.search) >-1 
          );
        });
        return valores
        },
        

   
    } ,

    data: function() {        
      
        return {
            mode: 'save',
            carregando: false,
            atualizando: false,   
            empresa:{}, 
            empresas:[],   // [] lista       
            value_empresa:[],// [this.empresas],            
            value_filial:[],            
            value_status:[],     
            filial:{}, 
            filiais: [],   // [] lista            
            //value_filial:[],// [] lista     
            
            status:{},
            statuss: [],   // [] lista            

            permissoes:[],
            permissao:{},
                                     
            ponpontoeletronicovalidacao:{},// [] lista   
            ponpontoeletronicovalidacoes:[],// [] lista
            search:'',
       
            value_id_area:'',            
            
            barra_inicial: 0,         
            barra_limite: 60000*5,        // temporizador 60.000 milisegundos refere-se a 1 minutos

            fields: [
                //{ key: 'id_pdf_confirmed', label: 'Nº validação', sortable: true },     
                { key: 'id_filial_erp', label: 'Filial', sortable: true },        
                { key: 'competencia', label: 'Competência', sortable: true, formatter: (value, key, ponpontoeletronicovalidacao) => {
                    return moment(ponpontoeletronicovalidacao.competencia).format('MM/YYYY').replace('Data inválida','-') ; }  },                                                                        
                { key: 'registro', label: 'Registro', sortable: true },  
                { key: 'nome', label: 'Nome', sortable: true },  
                { key: 'funcao', label: 'Função', sortable: true },                               
                { key: 'data_cadastro', label: 'Data Validação', sortable: true, formatter: (value, key, ponpontoeletronicovalidacao) => {
                    return moment(ponpontoeletronicovalidacao.data_cadastro).format('DD/MM/YYYY - HH:mm:ss ').replace('Data inválida','-') ; }  },                               
                { key: 'actions', label: 'Atualizar' },                
            ]
        }        
    },

    components: {
        Multiselect
    },
    methods: {
      

      temporizador() {        
      this.handle = setInterval(() =>{
        this.barra_inicial = this.barra_inicial + 1000
        if(this.barra_inicial >= this.barra_limite){
          this.barra_inicial = 0
          this.loadponpontoeletronicovalidacoes()
        }
      },1000)
      },

        loadEmpresas() {
          const url = `${baseApiUrl}/manutencao/rfi/empresa`
          axios.get(url).then(res => {
            this.empresas = res.data.map(empresa => {              
              return { id_empresa: empresa.id_empresa, empresa: empresa.nomeempresarial }
            })
          })
        },  
      
        loadGaragens() {
          const url = `${baseApiUrl}/manutencao/rfi/garagem`
          axios.get(url).then(res => {
            this.filiais = res.data.map(filial => {              
              return { id_filial_erp: filial.id_filial_erp, filial: filial.filial }
        //      return { ... fil, value: fil.id_filial_erp, filial: fil.filial }
            })
          })
        },        

        loadStatus() {
                      let params = {    
                "id_grupo": `${this.user.id_grupo}`,                                            
                "id_empresa": `${this.user.id_empresa}`,   
                 "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                                  
            };
          const url = `${baseApiUrl}/sac/status`
          axios.get(url,{params}).then(res => {
            this.statuss = res.data.map(sta => {              
               return { ... sta, value: sta.id_status, status: sta.status }
            })
          })
        },

        

        loadPermissao() {
            let params = {    
                "id_grupo": `${this.user.id_grupo}`,   
                         "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                                  
            };

          const url = `${baseApiUrl}/sac/permissao`
          axios.post(url,{params}).then(res => {
            this.permissoes = res.data.map(permissao => {              
               return { ... permissao, id_area: permissao.id_area}
            })
            this.loadponpontoeletronicovalidacoes()
            
          })
        },

        loadponpontoeletronicovalidacoes() {                
            let corpo = {    
                //"id_empresa": `${[this.value_empresa.map(e=> e.id_empresa_erp)]}`,                
                "id_filial": `${[this.value_filial.map(a => a.id_filial_erp)]}`,                
                //"id_status": `${[this.value_status.map(r => r.id_status)]}`,
                //"id_area": `${[this.permissoes.map(p => p.id_area)]}`,               
            };
 
            const url = `${baseApiUrl}/orc/pon/pontoeletronico`            
            axios.post(url,corpo).then(res => {                                
                this.carregando = false;
                this.ponpontoeletronicovalidacoes = res.data.map(ponpontoeletronicovalidacao => {
                            return {                              
                              id_pdf_confirmed: ponpontoeletronicovalidacao.id_pdf_confirmed, 
                              id_empresa_grupo: ponpontoeletronicovalidacao.id_empresa_grupo, 
                              id_funcionario: ponpontoeletronicovalidacao.id_funcionario,
                              id_empresa_erp: ponpontoeletronicovalidacao.id_empresa_erp,                              
                              id_filial_erp: ponpontoeletronicovalidacao.id_filial_erp, 
                              registro: ponpontoeletronicovalidacao.registro,
                              nome: ponpontoeletronicovalidacao.nome,
                              funcao: ponpontoeletronicovalidacao.funcao,
                              foto: ponpontoeletronicovalidacao.foto,
                              data_cadastro: ponpontoeletronicovalidacao.data_cadastro,
                              competencia: ponpontoeletronicovalidacao.competencia                              
                            }              
                                                })                          
                                                
                        })                             
        }, 

        loadCarregaSac(ponpontoeletronicovalidacao){
            this.ponpontoeletronicovalidacao = { ...ponpontoeletronicovalidacao }
        },

        postSac() {                        
        let corpo = { 
                "id_funcionario": `${this.user.id_funcionario}`,
                "parecer": `${this.ponpontoeletronicovalidacao.parecer}`,
                "id_solicitacao": `${this.ponpontoeletronicovalidacao.id_solicitacao}`,
                "id_status": `${this.ponpontoeletronicovalidacao.id_status}`,                
                "status": `${[this.statuss.filter(a => a.id_status == this.ponpontoeletronicovalidacao.id_status).map(a => a.status)]}`        };

        const url = `${baseApiUrl}/sac/solicitacoes/save`   

            axios.post(url,corpo).then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadponpontoeletronicovalidacoes()
                    //this.reset() limpar os objetos valores
                })
                .catch(showError)
        },

      limparFiltro(){
        this.search= ""
      },
  
    },  


    created(){
      this.loadPermissao()     
    },



  mounted() {    
        this.loadEmpresas()                                        
        this.loadGaragens()          
        this.loadStatus()        
        this.loadponpontoeletronicovalidacoes()     
        this.loadCarregaSac() 
        this.temporizador()
    },
    

}


</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#selecaostatusx{
    font-size: 0.7em;      
}

#re-nome{
    font-size: 0.6em;      
}

#funcao{
    font-size: 0.6em;      
}

#re-solicitante{
    font-size: 0.6em;      
    font-style: inherit;
    
}


#parecer{
    font-size: 0.6em;      
}


#rfilancamentos{   
    font-size: 0.9em;      
    text-align: center;    
}




</style>